export default __webpack_public_path__ + "media/images/temporary/fun-pumpkin-cdf7bad1124f1ff8b99e4dfc5462a761.jpg";